import { useIntl } from 'react-intl';
import type { ApiBindingCode } from '@agunity/api-v4';
import { DataGrid } from '@mui/x-data-grid';
import { IconButton, Stack } from '@mui/material';
import { ContentCopyOutlined } from '@mui/icons-material';

import AgTypography from '../../../stories/Styles/AgTypography';

import { useToast } from '../../../redux/hooks/toast';

const BindingTokenTable = ({ data }: {data: ApiBindingCode[]}) => {
  const messages = useIntl().formatMessage;
  const { toast } = useToast();

  return (
    <Stack gap={2}>
      <AgTypography contentStyle={'AP.H2.Bold'}>
        {messages({ id: 'BINDTOKEN_CODE' })}
      </AgTypography>

      <DataGrid 
        rows={data}
        hideFooter
        disableColumnMenu
        disableColumnSelector
        disableColumnFilter
        disableRowSelectionOnClick
        disableVirtualization
        sx={{ 
          '&, [role^=columnheader]': { color: 'black' },
          '&, [class^=MuiDataGrid]': { border: 'none', outline: 'none !important' },
          '& .MuiDataGrid-columnSeparator': { display: 'none' }, 
        }}
        columns={[
          { field: 'name', headerName: messages({ id: 'NAME2' }), sortable: false, width: 200 },
          { field: 'code', headerName: messages({ id: 'CODE' }), sortable: false, flex: 1 },
          { 
            field: 'copy', 
            headerName: messages({ id: 'COPY' }), 
            sortable: false,
            width: 80,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
              <IconButton 
                onClick={() => {
                  navigator.clipboard.writeText(`${params.row.name}: ${params.row.code}`);
                  toast('success', messages({ id: 'BINDTOKEN_CODE_CLIP' }), { temporary: true });
                }}
              >
                <ContentCopyOutlined fontSize='small' />
              </IconButton>
            )
          },
        ]}
      />
    </Stack>
  );
};

export default BindingTokenTable;